__turbopack_context__.v({
  "active": "styles-module__EowR6W__active",
  "checkbox": "styles-module__EowR6W__checkbox",
  "checkmark": "styles-module__EowR6W__checkmark",
  "disabled": "styles-module__EowR6W__disabled",
  "error": "styles-module__EowR6W__error",
  "input": "styles-module__EowR6W__input",
});
